/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const CalendarXIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M7.5,20 L16.5,11" />
      <path d="M7.5,11 L16.5,20" />
      <polyline points="4.5 2.5 0.5 2.5 0.5 23.5 23.5 23.5 23.5 2.5 19.5 2.5" />
      <rect x="4.5" y="0.5" width="3" height="4" />
      <rect x="16.5" y="0.5" width="3" height="4" />
      <path d="M7.5,2.5 L16.5,2.5" />
      <path d="M0.5,7.5 L23.5,7.5" />
    </g>
  </svg>
);

export default CalendarXIcon;
